import React, { useEffect, useState } from 'react';
import ProjectCard from './ProjectCard';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import s from '../styles/ProjectList.module.css';
import { useContext } from 'react';
import { AuthContext } from '../AuthContext';
import { ProjectContext } from '../ProjectContext';
import FirstStart from './FirstStart';
import Loader from './Loader';
import CreateProjectButton from './CreateProjectButton_firsttime';

const ProjectList = ({ userId }) => {
  const { fetchCurrentUser } = useContext(AuthContext);
  const { projects, fetchProjects, setProjects, projectsloading } = useContext(ProjectContext);

  const [inputUserId, setInputUserId] = useState('');
  const [activeUserId, setActiveUserId] = useState(null); // Текущий выбранный user_id
  const [search, setSearch] = useState('');

  // useEffect(() => {
  //       fetchCurrentUser(); // 💡 вызов из контекста
  //       fetchProjects();
  // }, []);

  useEffect(() => {
    if (userId) {
      setActiveUserId(userId);
      setInputUserId(userId.toString());
      fetchProjects(userId);
    } else {
      fetchCurrentUser();
      fetchProjects();
    }
  }, [userId]);
  

  const handleUserIdChange = (e) => {
    setInputUserId(e.target.value);
  };

  const handleLoadByUserId = () => {
    if (!inputUserId.trim()) return;
    const id = parseInt(inputUserId.trim());
    if (isNaN(id)) {
      alert("Введите корректный числовой ID");
      return;
    }
    setActiveUserId(id);
    fetchProjects(id); // Загружаем проекты по user_id
  };


  const handleDragEnd = async (result) => {
    if (!result.destination) return;

    const reordered = Array.from(projects);
    const [moved] = reordered.splice(result.source.index, 1);
    reordered.splice(result.destination.index, 0, moved);

    setProjects(reordered);

    const newOrder = reordered.map((p) => p.id).reverse();


    try {
      const res = await fetch('/api/projects/update-order', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ order: newOrder }),
      });
      const data = await res.json();
      if (!data.success) throw new Error(data.error || 'Ошибка сохранения');
    } catch (err) {
      console.error('Ошибка при обновлении порядка:', err);
    }
  };


  const handleProjectUpdate = (id, updatedData) => {
    setProjects((prev) =>
      prev.map((proj) =>
        proj.id === id ? { ...proj, ...updatedData } : proj
      )
    );
  };

const filteredProjects = projects
  .filter(p => p.arhiv !== 1)
  .filter((project) => {
    if (!search.trim()) return true;

    const query = search.toLowerCase();

    return (
      project.id.toString().includes(query) ||
      (project.project_name || "").toLowerCase().includes(query)
    );
  });
  
  if (projectsloading) {
    return <Loader />; // показываем крутилку
  }

  if (!projects || projects.filter(p => p.arhiv !== 1).length === 0) {
    return <FirstStart user_id={activeUserId} />;
  }
  

  return (
    <div className={s.list_wrapper}>
    <div className={s.user_input_wrapper}>
      <input
        type="text"
        placeholder="Поиск по ID или названию"
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className={s.search_input}
      />
        <CreateProjectButton user_id={userId} />
      </div>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="projects">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className={s.projects_div}
            >
              {Array.isArray(filteredProjects) && filteredProjects
              .map((project, index) => (
                <Draggable key={project.id} draggableId={project.id.toString()} index={index}>
                  {(provided) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={{
                        ...provided.draggableProps.style,
                        display: project.arhiv === 1 ? 'none' : undefined, // ❗️ прячем визуально
                      }}
                    >
                      <ProjectCard 
                        key={project.id}
                        project={project}
                        onProjectUpdate={handleProjectUpdate} />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </div>
  );
};

export default ProjectList;
